import * as React from 'react';
const SvgDevelopment = (props) => (
  <svg viewBox="0 0 195 136" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#development_svg__a)"
      stroke="#000"
      strokeWidth={3.6}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="m27.436 49.205-12.89 12.567 12.89 12.559M56.75 49.205l12.897 12.567L56.75 74.33M50.412 42.304l-16.48 38.928" />
      <path d="M115.606 132.302H14.089c-6.251 0-11.326-5.052-11.326-11.292V14.046c0-6.232 5.067-11.292 11.326-11.292h139.127c6.251 0 11.326 5.052 11.326 11.292v23.56M3.528 29.934h160.24M83.538 61.772h22.313M20.68 111.693h74.002M54.745 16.25H62.1M35.092 16.25h7.885M16.835 16.25h6.157" />
      <path d="m189.135 108.466 3.11-10.221-8.453-3.36a32.669 32.669 0 0 0-1.626-13.315l7.396-4.792-5.052-9.42-8.366 3.581a32.74 32.74 0 0 0-10.592-8.27l1.831-8.601-10.253-3.1-3.37 8.427a32.969 32.969 0 0 0-13.355 1.621l-4.807-7.373-9.447 5.036 3.591 8.341a32.657 32.657 0 0 0-8.295 10.56l-8.627-1.825-3.11 10.222 8.453 3.36a32.685 32.685 0 0 0 1.626 13.314l-7.395 4.792 5.051 9.42 8.366-3.581a32.748 32.748 0 0 0 10.592 8.271l-1.831 8.6 10.253 3.101 3.37-8.428a32.981 32.981 0 0 0 13.355-1.621l4.807 7.373 9.447-5.036-3.591-8.341a32.68 32.68 0 0 0 8.296-10.56l8.626 1.825Z" />
      <path d="M167.869 98.273c3.41-9.299-1.387-19.592-10.714-22.99-9.326-3.4-19.65 1.383-23.06 10.68-3.409 9.3 1.388 19.592 10.714 22.991 9.327 3.399 19.651-1.383 23.06-10.681Z" />
    </g>
    <defs>
      <clipPath id="development_svg__a">
        <path fill="#fff" d="M0 0h195v136H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDevelopment;
